// assets/uc-free-entry.js

const API_BASE = 'https://entries-allocator.ultracoresystems.workers.dev';

async function postJson(url, payload) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const text = await res.text();
  try {
    const json = text ? JSON.parse(text) : null;
    if (json && typeof json === 'object') json.__status = res.status;
    return json;
  } catch {
    return { ok: false, code: 'BAD_JSON', status: res.status, raw: text };
  }
}

// Turnstile callback (must be global for data-callback)
window.ucTurnstileCb = function (token) {
  const input = document.getElementById('cf_turnstile_token');
  if (input) input.value = token;
};

function showMsg(form, type, text) {
  const msg = form.querySelector('.uc-message');
  if (!msg) return;
  msg.hidden = false;
  msg.textContent = text;
  msg.dataset.type = type;
}

function clearMsg(form) {
  const msg = form.querySelector('.uc-message');
  if (!msg) return;
  msg.hidden = true;
  msg.textContent = '';
  msg.dataset.type = '';
}

function setLoading(form, on, text) {
  const overlay = form.closest('.uc-free-entry__form')?.querySelector('[data-uc-loading]');
  if (!overlay) return;
  overlay.setAttribute('aria-hidden', on ? 'false' : 'true');

  const t = overlay.querySelector('.uc-loading__text');
  if (t && text) t.textContent = text;
}

/* PHONE helpers (US only) */
function digits10(str) {
  const d = String(str || '').replace(/\D/g, '');
  return d.length === 10 ? d : '';
}

function onlyDigits(str) {
  return String(str || '').replace(/\D/g, '');
}

function formatUsPhoneInput(value) {
  const d = onlyDigits(value).slice(0, 10);

  if (d.length === 0) return '';
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)})${d.slice(3)}`;
  return `(${d.slice(0, 3)})${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

function buildPhoneFull(form) {
  const cc = form.querySelector('select[name="country_code"]')?.value?.trim() || '+1';
  const local = form.querySelector('input[name="phone_local"]')?.value || '';
  const d10 = digits10(local);
  if (!d10) return null;

  const full = `${cc}${d10}`;
  const hidden = form.querySelector('[data-uc-phone-full]');
  if (hidden) hidden.value = full;

  return { full, localDigits: d10, cc };
}

function getFormFromTarget(target) {
  return target?.closest?.('[data-uc-free-entry-form]') || null;
}

// store otpProof per form
const otpProofs = new WeakMap();
function setOtpProof(form, proof) { otpProofs.set(form, String(proof || '')); }
function getOtpProof(form) { return otpProofs.get(form) || ''; }

// ===== TURNSTILE token =====
function getTurnstileToken(form) {
  return form.querySelector('#cf_turnstile_token')?.value?.trim() || '';
}

// ✅ Bind ONCE, survives Shopify hot reload / section swaps
if (!window.__UC_FREE_ENTRY_BOUND__) {
  window.__UC_FREE_ENTRY_BOUND__ = true;

    // Live phone formatting
  document.addEventListener('input', (e) => {
    const input = e.target.closest('#phone_local');
    if (!input) return;

    const digits = onlyDigits(input.value).slice(0, 10);
    input.value = formatUsPhoneInput(digits);
  });

  // Block non-number keys while still allowing control keys
  document.addEventListener('keydown', (e) => {
    const input = e.target.closest('#phone_local');
    if (!input) return;

    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
    ];

    if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  });

  // Clean pasted values too
  document.addEventListener('paste', (e) => {
    const input = e.target.closest('#phone_local');
    if (!input) return;

    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    const digits = onlyDigits(pasted).slice(0, 10);
    input.value = formatUsPhoneInput(digits);
  });

  // Already Have Code (show OTP)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-uc-have-code]');
    if (!btn) return;

    const form = getFormFromTarget(btn);
    if (!form) return;

    const otpWrap = form.querySelector('[data-uc-otp]');
    const otpInput = form.querySelector('input[name="otp_code"]');
    if (otpWrap) otpWrap.style.display = 'block';
    otpInput?.focus();
  });

  // Send Code
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-uc-send-code]');
    if (!btn) return;

    const form = getFormFromTarget(btn);
    if (!form) return;

    clearMsg(form);

    // honeypot
    const hp = form.querySelector('input[name="website"]')?.value?.trim();
    if (hp) return;

    const otpWrap = form.querySelector('[data-uc-otp]');
    const otpInput = form.querySelector('input[name="otp_code"]');

    const phone = buildPhoneFull(form);
    if (!phone) {
      showMsg(form, 'error', 'Enter a valid 10-digit phone number first.');
      return;
    }

    btn.disabled = true;
    setLoading(form, true, 'Sending code…');

    try {
      const turnstileToken = requireTurnstile(form);
      if (!turnstileToken) { btn.disabled = false; setLoading(form, false); return; }

      const r = await postJson(`${API_BASE}/otp/send`, {
        phone: phone.full,
        turnstileToken,
      });

      if (r?.ok && r.code === 'OTP_SENT') {
        if (otpWrap) otpWrap.style.display = 'block';
        otpInput?.focus();
        showMsg(form, 'success', 'Code sent! Enter the code, then press Enter To Win.');
      } else if (r?.code === 'OTP_SEND_COOLDOWN' || r?.code === 'OTP_SEND_IP_COOLDOWN') {
        showMsg(form, 'error', `Please wait ${r?.retry_after_seconds || 'a moment'} seconds before requesting another code.`);
      } else if (r?.code === 'OTP_SEND_DAILY_LIMIT') {
        showMsg(form, 'error', 'You have reached the daily limit for verification codes. Please try again tomorrow.');
      } else {
        showMsg(form, 'error', 'Could not send code: ' + (r?.code || 'unknown'));
      }
    } catch (err) {
      console.error(err);
      showMsg(form, 'error', 'Network error sending code. Please try again.');
    } finally {
      setLoading(form, false);
      btn.disabled = false;
    }
  });

  // Submit free entry: verify OTP (if needed) -> /free-entry
  document.addEventListener('submit', async (e) => {
    const form = e.target?.closest?.('[data-uc-free-entry-form]');
    if (!form) return;

    e.preventDefault();
    clearMsg(form);

    // honeypot
    const hp = form.querySelector('input[name="website"]')?.value?.trim();
    if (hp) return;

    // required fields
    const first_name = form.querySelector('#first_name')?.value?.trim() || '';
    const last_name  = form.querySelector('#last_name')?.value?.trim() || '';
    const email      = form.querySelector('#email')?.value?.trim() || '';
    const state      = form.querySelector('#location_state')?.value?.trim() || '';

    if (!first_name) return showMsg(form, 'error', 'Please enter your first name.');
    if (!last_name)  return showMsg(form, 'error', 'Please enter your last name.');
    if (!email)      return showMsg(form, 'error', 'Please enter your email.');
    if (!state)      return showMsg(form, 'error', 'Please select your state.');

    const phone = buildPhoneFull(form);
    if (!phone) return showMsg(form, 'error', 'Enter a valid 10-digit phone number.');

    // consents
    const emailConsent = form.querySelector('#email_consent')?.checked === true;
    const smsConsent   = form.querySelector('#sms_consent')?.checked === true;
    if (!emailConsent) return showMsg(form, 'error', 'Please check the email consent box to continue.');
    if (!smsConsent)   return showMsg(form, 'error', 'Please check the SMS consent box to continue.');

    // Turnstile token (required by your Worker for /free-entry)
    const turnstileToken = getTurnstileToken(form);
    if (!turnstileToken) return showMsg(form, 'error', 'Please complete the verification and try again.');

    const submitBtn = form.querySelector('[data-uc-submit]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      // 1) ensure otpProof
      let otpProof = getOtpProof(form);
      const otpCode = form.querySelector('#otp_code')?.value?.trim() || '';

      if (!otpProof) {
        if (!/^\d{4,10}$/.test(otpCode)) {
          const otpWrap = form.querySelector('[data-uc-otp]');
          if (otpWrap) otpWrap.style.display = 'block';
          form.querySelector('#otp_code')?.focus();
          if (submitBtn) submitBtn.disabled = false;
          return showMsg(form, 'error', 'Enter the verification code we texted you.');
        }

        setLoading(form, true, 'Verifying code…');

        const turnstileToken = requireTurnstile(form);
        if (!turnstileToken) { setLoading(form, false); if (submitBtn) submitBtn.disabled = false; return; }

        const v = await postJson(`${API_BASE}/otp/verify`, {
          phone: phone.full,
          otpCode,
          turnstileToken,
        });

        if (!v?.ok || !v?.otpProof) {
          setLoading(form, false);
          if (submitBtn) submitBtn.disabled = false;
          return showMsg(form, 'error', 'Invalid code. Please try again.');
        }

        otpProof = v.otpProof;
        setOtpProof(form, otpProof);
      }

      // 2) submit /free-entry
      setLoading(form, true, 'Submitting entry…');

      const r = await postJson(`${API_BASE}/free-entry`, {
        turnstileToken,
        otpProof,
        phone: phone.full,
        email,
        first_name,
        last_name,
        state,
        sms_opt_in: smsConsent,     // ✅ boolean for worker
        email_consent: emailConsent,
        sms_consent: smsConsent,
        website: '',                // honeypot
      });

      setLoading(form, false);

      if (r?.ok) {
        showMsg(form, 'success', '✅ Entry submitted! Good luck!');

        // Track a successfully submitted free entry in Meta
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'CompleteRegistration', {
            content_name: 'Free Entry Submission',
            content_category: 'Giveaway Free Entry',
            status: 'submitted',
          });
        } else {
          console.warn('Meta Pixel fbq is not available.');
        }

        // optional: hide OTP section again
        const otpWrap = form.querySelector('[data-uc-otp]');
        if (otpWrap) otpWrap.style.display = 'none';

        setTimeout(() => {
          window.location.href = '/pages/one-more-step';
        }, 1200);
      } else if (r?.code === 'PROMO_CLOSED') {
        showMsg(form, 'error', 'This giveaway is currently closed.');
      } else if (String(r?.code || '').startsWith('OTP_PROOF')) {
        setOtpProof(form, '');
        showMsg(form, 'error', 'Verification expired. Please request a new code and try again.');
      } else if (r?.code === 'DUPLICATE') {
        showMsg(form, 'error', 'It looks like you already entered (duplicate detected).');
      } else {
        showMsg(form, 'error', 'Could not submit entry: ' + (r?.code || 'unknown'));
      }
    } catch (err) {
      console.error(err);
      setLoading(form, false);
      showMsg(form, 'error', 'Network error submitting entry. Please try again.');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
}

function requireTurnstile(form) {
  const token = getTurnstileToken(form);
  if (!token) {
    showMsg(form, 'error', 'Please complete the verification and try again.');
    return '';
  }
  return token;
}